// lien en local
export const DEFAULT_ROUTE = process.env.REACT_APP_DEFAULT_ROUTE;
export const SERVER_ROUTE = process.env.REACT_APP_SERVER_ROUTE;
export const FRONTEND_ROUTE = process.env.REACT_APP_FRONTEND_ROUTE;
// env-cmdrc

// lien en production
// export const SERVER_ROUTE = "https://api-training.bakeli.tech";
// export const FRONTEND_ROUTE = "https://school-training.bakeli.tech";
// export const DEFAULT_ROUTE = "https://api-training.bakeli.tech/api/v1/";

export const REGISTER_API_ROUTE = DEFAULT_ROUTE + "users/";
export const LOGIN_API_ROUTE = DEFAULT_ROUTE + "login/";
export const LOGOUT_API_ROUTE = DEFAULT_ROUTE + "logout/";

export const DOMAINES_API_ROUTE = DEFAULT_ROUTE + "domaine/";

export const CATEGORIES_API_ROUTE = DEFAULT_ROUTE + "category/";

export const PARCOURS_API_ROUTE = DEFAULT_ROUTE + "parcours/";

export const QUESTIONS_API_ROUTE = DEFAULT_ROUTE + "question/";

export const CHOICES_API_ROUTE = DEFAULT_ROUTE + "choice/";

export const RECOMMENDATION_API_ROUTE = DEFAULT_ROUTE + "recommendation/";

export const QUIZZ_PROFILE_API_ROUTE = DEFAULT_ROUTE + "quizzprofile/";

export const ATTEMPTED_API_ROUTE = DEFAULT_ROUTE + "attemptedquestion/";

export const TECHNOLOGY_API_ROUTE = DEFAULT_ROUTE + "technology/";

export const NIVEAU_API_ROUTE = DEFAULT_ROUTE + "niveau/";

export const PLAY_API_ROUTE = DEFAULT_ROUTE + "play/"; //+ quiz_profile_id/completed

export const SEND_RESPONSE_API_ROUTE = DEFAULT_ROUTE + "send_response/"; // <int:question_id>/<int:quiz_profile_id>/<int:response_id>/<str:completed>

export const TESTER_NIVEAU_API_ROUTE = DEFAULT_ROUTE + "tester_niveau/"; //

export const SEND_RESPONSE_NIVEAU_API_ROUTE =
  DEFAULT_ROUTE + "send_response_niveau/";

export const ATELIERS = DEFAULT_ROUTE + "atelier/";

/********************************** CHALLENGES ROUTES ************************************************ */
export const EXERCICE_API_ROUTE = DEFAULT_ROUTE + "exercice/";

export const REPONSE_API_ROUTE = DEFAULT_ROUTE + "reponse/";

export const ATTEMPTED_REPONSE_API_ROUTE = DEFAULT_ROUTE + "attempted_exo/";

export const CHALLENGE_EXO_API_ROUTE = DEFAULT_ROUTE + "challengeprofile/";

export const PLAY_EXO_API_ROUTE = DEFAULT_ROUTE + "play_exo/";

export const SEND_RESPONSE_EXO_API_ROUTE = DEFAULT_ROUTE + "send_response_exo/";

export const PLAY_EXO_JS_TS_API_ROUTE = DEFAULT_ROUTE + "play_exo_js_ts/";

export const SEND_RESPONSE_EXO_JS_TS_API_ROUTE =
  DEFAULT_ROUTE + "send_response_exo_js_ts/";

export const TEST_CODE_JS_TS_API_ROUTE = DEFAULT_ROUTE + "test_code_js_ts/";
export const TEST_CODE_API_ROUTE = DEFAULT_ROUTE + "test_code/";

export const RESET_CHALLENGE_API_ROUTE = DEFAULT_ROUTE + "reset_challenge/";
export const RESET_CHALLENGE_JS_TS_API_ROUTE = DEFAULT_ROUTE + "reset_challenge_js_ts/";

/************************************************************************************************** */
